import React from 'react';
import { isVideo } from 'helpers';
import PostImage from 'components/generic-components/post/PostImage';

const ProfileImageFilter = ({ files }) => (
  <>
    {files.length > 0 && files.map(img => {
      if(!isVideo(img.orig_src)){
        return(
          <PostImage
            srcset={img.srcset}
            image={img.thumb_src}
            orginal={img.orig_src}
            imgStyle={{ width: '100%', height: '118px' }}
          />
        )
      }       
    })}
  </>
);

export default ProfileImageFilter;
